<template>
  <div class="teaching-schedule-query-student-arrange">
    <PlatDataPanelSelect custom-type="arrange"
                         :custom-id="customId"
                         :data-types="['semester']"
                         :border="false"
                         semesterLabel="选择学期">
      <template #default="scope">
        <TeachingScheduleQueryStudentArrangeMain :key="scope.semester"
                                                 :student-id="rowData.id"
                                                 :extra-params="scope"
                                                 v-bind="$attrs"></TeachingScheduleQueryStudentArrangeMain>
      </template>
      <template #extra="scope">
        <action-form :action="$contextPath('/workspace/manager/teaching/schedule/query/student/exportArrange')"
                     :pre-handle-params="paramResolver"
                     :form-params="scope"
                     target="_blank">
          <template #default="{submit}">
            <el-button size="mini"
                       type="primary"
                       plain
                       @click="submit">导出学生课表</el-button>
          </template>
        </action-form>
      </template>
    </PlatDataPanelSelect>
  </div>
</template>

<script>
import PlatDataPanelSelect from '../../../../../wrapper/panel/PlatDataPanelSelect'
import TeachingScheduleQueryStudentArrangeMain from './main'
import routeConfig from '../../../../../../../../../constants/routeConfig'
export default {
  name: 'TeachingScheduleQueryStudentArrange',
  components: {
    PlatDataPanelSelect,
    TeachingScheduleQueryStudentArrangeMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      customId: ''
    }
  },
  methods: {
    paramResolver () {
      return {
        postId: this.rowData.id
      }
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataGrid.param]
  }
}
</script>

<style lang="scss">
  .teaching-schedule-query-student-arrange {
    height: 100%;
  }
</style>
